<div
  class="badge"
  [class]="size"
  [attr.data-viewport]="viewport"
  [attr.data-type]="type"
>
  <strong [attr.data-viewport]="viewport">{{ label }}</strong>
</div>
